import React, { Component, PureComponent } from "react";
import {
  Row,
  Col,
  Card,
  Modal,
  FormControl,
  Form,
  Button,
} from "react-bootstrap";
import classes from "./myprofile.module.css";
import Loader from "react-loader-advanced";
import loading from "../../Assets/Images/loader-green.gif";
import { connect } from "react-redux";
import * as actionTypes from "../../Action/Index";
import UpdatedOtpModal from "./UdatedOtpModal";
import Backdrop from "../Popup/Backdrop/Backdrop";
import SweetAlert from "../commonComponents/SweetAlert";
import Spinner from "react-bootstrap/Spinner";

class Myprofile extends Component {
  constructor() {
    super();
    this.state = {
      abc: 1,
      editable: false,
      mobileChange: false,
      nameChange: false,
      updatedMobileVerification: false,
      backdrop: false,
      name: "",
      mobile: "",
    };
  }

  componentDidMount = () => {
    this.props.onGetCandidateProfile();
  };

  componentWillReceiveProps(nextProps) {
    console.log(nextProps);
    if (nextProps.profileData) {
      this.setState({
        name: nextProps.profileData.name,
        mobile: nextProps.profileData.mobile,
      });
    }
  }

  componentWillUnmount() {
    this.setState({
      nameChange: false,
      mobileChange: false,
    });
  }

  closeModalVerify = () => {
    //this.setState
  };

  handleEdit = (event, status) => {
    event.preventDefault();
    this.setState({
      editable: status,
    });
    if (status === false && this.props.otpUpdated) {
      console.log("first");
      this.props.resetlast();
      this.setState({
        editable: status,
        mobile: this.props.profileData.mobile,
        updatedMobileVerification: false,
        backdrop: true,
        mobileChange: false,
      });
      //this.props.resetStateVerifyState()
      this.props.onGetCandidateProfile();
      if (this.state.nameChange && this.inputName.value.length) {
        this.props.updatedNameVerification(this.inputName.value);
      }
    } else if (status === false && !this.props.mobileUpdated) {
      console.log("second");
      this.setState({
        editable: false,
        mobile: this.props.profileData.mobile,
        mobileChange: false,
      });
      this.props.resetStateVerifyState();
      this.inputMobile.value = this.props.profileData.mobile;
      if (this.state.nameChange && this.inputName.value.length) {
        this.props.updatedNameVerification(this.inputName.value);
      }
    } else if (this.state.nameChange && this.inputName.value.length) {
      console.log("third");
      this.props.updatedNameVerification(this.inputName.value);
    }
  };

  handleVerification = (field, id) => {
    this.props[field](this[id].value); //api call
    this.setState({
      [field]: true,
      backdrop: true,
    });
  };

  handleFieldChange = (id, field) => {
    if (
      parseInt(this[id].value) !== this.props.profileData[field] &&
      this.inputMobile.value.length === 10
    ) {
      this.setState({
        [`${field}Change`]: true,
      });
    } else {
      this.setState({
        [`${field}Change`]: false,
      });
    }
  };

  handleOk = (status) => {
    this.setState({
      backdrop: status,
      nameChange: false,
      mobileChange: false,
    });
    this.props.resetStateVerifyState();
  };

  closeModal = () => {
    this.setState({
      updatedMobileVerification: false,
    });
  };
  render() {
    console.log("check", this.state);
    console.log("check2", this.props);
    // && this.props.mobileUpdatedError ?
    //             <SweetAlert type="warning" show="true" msg="Mobile Verified Successfully"/>
    //             :
    return (
      <div>
        {this.state.updatedMobileVerification &&
        !this.props.mobileUpdatedError ? (
          <>
            <UpdatedOtpModal
              open={this.state.updatedMobileVerification}
              mobile={this.inputMobile.value}
              closeModal={this.closeModal}
            />
          </>
        ) : this.props.mobileUpdatedError ? (
          <>
            <Backdrop open={this.state.backdrop} />
            <SweetAlert
              type="warning"
              show="true"
              msg="Something went wrong !"
              handleOk={this.handleOk}
            />
          </>
        ) : null}
        {this.props.nameUpdated ? (
          <>
            <Backdrop open={this.state.backdrop} />
            <SweetAlert
              type="success"
              show="true"
              msg="Data saved successfully"
              handleOk={this.handleOk}
            />
          </>
        ) : null}
        <Row>
          <Col md={12}>
            <h3 className={classes.heading}>My Personal Details</h3>
          </Col>
        </Row>
        <Loader
          show={this.props.loader}
          message={<img src={loading} />}
          foregroundStyle={{ color: "#00a99d" }}
          backgroundStyle={{ backgroundColor: "#F3EFEF" }}
        >
          <Row className={`${classes.gapTop} justify-content-md-center`}>
            <Col md={11}>
              <div className={classes.createBox}>
                <Form className={classes.form}>
                  <Form.Row className={classes.Row}>
                    <Form.Label column sm={3} className={classes.InputFont}>
                      Full Name:
                    </Form.Label>
                    <Col sm={9}>
                      <Form.Control
                        type="text"
                        className={`${classes.Input} ${classes.nameInput}`}
                        name="fullName"
                        autoComplete="off"
                        maxLength="52"
                        id="inputtag"
                        tabIndex="1"
                        placeholder="John Doe"
                        min={1}
                        defaultValue={this.state.name}
                        required={true}
                        disabled={this.state.editable ? false : true}
                        style={{ backgroundColor: "white" }}
                        ref={(el) => (this.inputName = el)}
                        onChange={() =>
                          this.handleFieldChange("inputName", "name")
                        }
                        // onFocus={() => { this.setState({   fileRequired: false,
                        //     invalidFormat: false,
                        //     skillsRequired: false,
                        //     skillsErrorMsg: "",
                        //     mobileErrorMsg: "",
                        //     emailErrorMsg: "",
                        //     yearsErrorMsg: ""}) }}
                        // onInput={() => { this.setState({ nameErrorMsg: "" }) }}
                      />
                      {/* <span className={classes.nameValidation}>&nbsp;{this.state.nameErrorMsg}</span> */}
                    </Col>
                  </Form.Row>
                  <Form.Row className={classes.Row}>
                    <Form.Label column sm={3} className={classes.InputFont}>
                      Mobile Number:
                    </Form.Label>
                    <Col sm={9}>
                      <Form.Control
                        type="text"
                        className={`${classes.Input} ${classes.nameInput}`}
                        name="mobileNumber"
                        autoComplete="off"
                        maxLength="52"
                        id="inputtag"
                        tabIndex="1"
                        type="number"
                        defaultValue={this.state.mobile}
                        required={true}
                        maxLength={10}
                        placeholder="9899456730"
                        disabled={this.state.editable ? false : true}
                        ref={(el) => (this.inputMobile = el)}
                        onChange={() =>
                          this.handleFieldChange("inputMobile", "mobile")
                        }
                        style={{ backgroundColor: "white" }}
                      />
                      {this.state.editable ? (
                        this.props.otpUpdated ? (
                          <span className={classes.verify}>Done</span>
                        ) : (
                          <span
                            className={classes.verify}
                            style={{
                              color: this.state.mobileChange
                                ? "#51be60"
                                : "gray",
                              display: this.state.editable ? "block" : "none",
                              cursor: this.state.mobileChange
                                ? "pointer"
                                : "auto",
                            }}
                            onClick={() =>
                              this.state.mobileChange
                                ? this.handleVerification(
                                    "updatedMobileVerification",
                                    "inputMobile"
                                  )
                                : null
                            }
                          >
                            Verify
                          </span>
                        )
                      ) : null}
                      {/* <span className={classes.nameValidation}>&nbsp;{this.state.nameErrorMsg}</span> */}
                    </Col>
                  </Form.Row>
                  <Form.Row className={classes.Row}>
                    <Form.Label column sm={3} className={classes.InputFont}>
                      Email Id:
                    </Form.Label>
                    <Col sm={9}>
                      <Form.Control
                        type="text"
                        className={`${classes.Input} ${classes.nameInput}`}
                        name="email"
                        autoComplete="off"
                        maxLength="52"
                        id="inputtag"
                        tabIndex="1"
                        defaultValue={
                          this.props.profileData && this.props.profileData.email
                        }
                        required={true}
                        placeholder="abc@abc.com"
                        disabled={true}
                      />

                      {/* <span className={classes.nameValidation}>&nbsp;{this.state.nameErrorMsg}</span> */}
                    </Col>
                  </Form.Row>
                  <Row className={classes.buttons}>
                    <Col md={9}></Col>
                    <Col md={3} className={classes.button}>
                      {this.state.editable ? (
                        <Button
                          className={classes.Button_2}
                          type="submit"
                          variant="warning"
                          onClick={(event) => this.handleEdit(event, false)}
                        >
                          Save
                        </Button>
                      ) : (
                        <Button
                          className={classes.Button_2}
                          type="submit"
                          variant="warning"
                          onClick={(event) => this.handleEdit(event, true)}
                        >
                          Edit
                        </Button>
                      )}
                    </Col>
                  </Row>
                </Form>
              </div>
            </Col>
          </Row>
        </Loader>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    //    countryArr : state.employeeReducer.countryArr,
    profileData: state.employeeReducer.candiDateProfile,
    loader: state.employeeReducer.loader,
    mobileUpdated: state.employeeReducer.mobileUpdated,
    mobileUpdatedError: state.employeeReducer.mobileUpdatedError,
    otpUpdated: state.employeeReducer.otpUpdated,
    otpUpdatedError: state.employeeReducer.otpUpdatedError,
    nameUpdated: state.employeeReducer.nameUpdated,
    nameUpdatedError: state.employeeReducer.nameUpdatedError,
    //    serverErrorStatus: state.employeeReducer.myProfileErrorStatus,
    //    updateStatus : state.employeeReducer.updateStatus,
    //    mobileStatus : state.employeeReducer.mobileStatus
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    onGetCandidateProfile: () => dispatch(actionTypes.getCandidateProfile()),
    updatedMobileVerification: (mobile) =>
      dispatch(actionTypes.updatedMobileVerification(mobile)),
    updatedNameVerification: (name) =>
      dispatch(actionTypes.updatedNameVerification(name)),
    resetStateVerifyState: () => dispatch(actionTypes.resetStateVerifyState()),
    resetlast: () => dispatch(actionTypes.resetlast()),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Myprofile);
